import React from 'react';	
import PropTypes from 'prop-types';	
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';	
import { PanelGroup, Panel, Checkbox, FormGroup } from 'react-bootstrap';	
import { FormsList } from './SelectForms.jsx';	
import validateRole from  '../../utils/formValueGenerator';

 export default class AdditionalInsuredSelector extends React.Component {	
    constructor(props) {	

         super(props);	
        this.handleSelect = this.handleSelect.bind(this);	
        this.handleForms = this.handleForms.bind(this);	
        this.insuredNamesArray = [];
        this.insKeys = ['additionalInsuredName', 'secondAdditionalInsuredName', 'thirdAdditionalInsuredName'];	
        this.insFormKeys = ['additionalInsuredForms', 'secondAdditionalInsuredForms', 'thirdAdditionalInsuredForms'];	
        this.insRoleKeys = ['additionalInsuredRole', 'secondAdditionalInsuredRole', 'thirdAdditionalInsuredRole'];	
        this.insRelKeys = ['additionalInsuredRelationship', 'secondAdditionalInsuredRelationship', 'thirdAdditionalInsuredRelationship'];	
        this.props.submission.additionalInsuredArray && this.props.submission.additionalInsuredArray.map((insured, id) => {	
            const label = insured[this.insKeys[id]];	
            const value = insured[this.insKeys[id]];	
            const checked = insured.noDisplayInMail ? false : true	
            if (checked)	
                this.insuredNamesArray = [...this.insuredNamesArray, { label: label, value: value, checked: checked }];	
        });	
        this.state = {	
            activeKey: 0,	
            checked: false,	
            additionalInsuredArray: this.props.submission.additionalInsuredArray,
            insuredNames: this.insuredNamesArray,
            newlyAddedFormsList: {0:'', 1:'', 2:''}
        }	
    }	

     handleSelect(activeKey) {	
        this.setState({ activeKey });	
    }
    componentDidMount() {
        this.props.submission.additionalInsuredArray.map((insured, idx) => {
            if (insured[this.insRelKeys[idx]] !== 'Lender/Mortgagee'
            && insured[this.insRoleKeys[idx]] !== 'Lender/Mortgagee' && !insured.approvedForms) {
                this.handleChangeOption(null,idx)
            }
        })
    }	

     handleForms(event, idx) {	
        let insName;
        const checked = !event.target.checked	
        this.setState({ checked });	
        if (event.target.checked) {	
            insName = !!this.state.insuredNames ? [...this.state.insuredNames, {label: event.target.name}] : [{label:event.target.name}];	

         } else {	
            insName = this.state.insuredNames.filter(i=>i.label!==event.target.name);
        }
        this.setState({ insuredNames: insName });	
        this.props.updateAdditionalInsuredList(insName);	
    }	
    handleChangeOption = (event, index) => {
        if(event === null) {
            this.props.onChange(index, '')
        } else {
        const { additionalInsuredArray } = this.state

        let modifiedForms = additionalInsuredArray[index]
            && (additionalInsuredArray[index].approvedForms) ? (additionalInsuredArray[index]).approvedForms.split(',') : 
            ((additionalInsuredArray[index])[this.insFormKeys[index]]
            && (additionalInsuredArray[index])[this.insRelKeys[index]] === 'Lender/Mortgagee'
            || (additionalInsuredArray[index])[this.insRoleKeys[index]] === 'Lender/Mortgagee') ? (additionalInsuredArray[index])[this.insFormKeys[index]].split(','): '';	
        const checked = !event.target.checked	
        const newlyAddedFormsList = this.state.newlyAddedFormsList;
        newlyAddedFormsList[index] = newlyAddedFormsList[index]+','+event.target.name;
        
        if (event.target.checked) {	
            modifiedForms = !!modifiedForms ? modifiedForms.concat(event.target.name) : [event.target.name];	

         } else {	
            modifiedForms = modifiedForms.filter(item => item !== event.target.name)
            newlyAddedFormsList[index] = newlyAddedFormsList[index].replaceAll(`,${event.target.name}`, '')
        }
        this.setState({ checked, newlyAddedFormsList });	
        const formValues = modifiedForms.join(',');	
        this.props.onChange(index, formValues);	
    }
    }	

     render() {
        if(!this.props.submission.additionalInsuredArray) { return null }
        let additionalInsuredNamesArray = [];
        let roleRelArray = [];
        const additionalInsuredName = this.props.submission.additionalInsuredArray.map((insured,idx) => {	
            const label = insured[this.insKeys[idx]];	
            const value = insured[this.insKeys[idx]];

            roleRelArray.push([...(validateRole(FormsList, insured[this.insRelKeys[idx]]))]);
            additionalInsuredNamesArray = [...additionalInsuredNamesArray, { label: label, value: value, checked: true }];	
        });	
        const uncheck = !!this.props.submission.coverages.gl.additionalInsureds && this.props.submission.coverages.gl.additionalInsureds.selected
        const secondAdditionalInsuredForms = this.props.submission.secondAdditionalInsuredForms && this.props.submission.secondAdditionalInsuredForms.split(',');	
        const additionalInsuredForms = this.props.submission.additionalInsuredForms && this.props.submission.additionalInsuredForms.split(',');	
        const thirdAdditionalInsuredForms = this.props.submission.thirdAdditionalInsuredForms && this.props.submission.thirdAdditionalInsuredForms.split(',');	

         return (	
            <div className="col-xs-12 pad_10_0 AdditionalInsuredSelectorContainer">	
                <h4 className="quoteTitle" style={{fontSize:'1.5em'}}>Additional Insured</h4>	
                <div className="col-xs-12 nopad" style = {{paddingTop:'10px'}}>	
                    <div className="col-xs-12 nopad">	
                        <PanelGroup className="checkbox-group" accordion id="accordion-group" activeKey={this.state.activeKey} onSelect={this.handleSelect}>	
                            {this.props.submission.additionalInsuredArray.map((insured, idx) =>	
                                <Panel eventKey={idx} key={idx}>	
                                    <Panel.Heading>	
                                         <Checkbox className="col-xs-12 nopad" style={{marginBottom: '0', marginTop: '0'}}	
                                    onChange={(e) => this.handleForms(e, idx)}
                                    checked={this.state.insuredNames.some(person => person.label === insured[this.insKeys[idx]])
                                    && !!this.state.additionalInsuredArray[idx][this.insFormKeys[idx]]}	
                                    // disabled={insured[this.insRelKeys[idx]] === 'Lender/Mortgagee' || insured[this.insRoleKeys[idx]] === 'Lender/Mortgagee'}
                                    name={insured[this.insKeys[idx]]}
                                    ><p style={{marginBottom:'0px'}}>{insured[this.insKeys[idx]]}</p></Checkbox>
                                        <div className="col-sm-1 col-xs-2">	
                                            <Panel.Title toggle></Panel.Title>	
                                        </div>	
                                    </Panel.Heading>	
                                    <Panel.Body collapsible style={{marginLeft:'20px'}}>	
                                        <FormGroup className="checkbox-group">	
                                            {[...new Set(roleRelArray[idx])].map((option, index) => {	
                                                option.defaultChecked = false;	
                                                if (this.state.insuredNames.some(person => person.label === insured[this.insKeys[idx]])) {	
                                                    option.disabled = false
                                                    if(this.state.newlyAddedFormsList[`${idx}`] && this.state.newlyAddedFormsList[`${idx}`].includes(option.mutuallyExclusive) || (insured.approvedForms && insured.approvedForms.includes(option.mutuallyExclusive))) {
                                                        option.disabled = true;
                                                    } else {
                                                        option.disabled = false;
                                                    }	
                                                } else {	
                                                    option.disabled = true;	
                                                } 
                                                if (idx === 0 && additionalInsuredForms.includes(option.value) 
                                                    && ((insured.approvedForms && insured.approvedForms.includes(option.value)) || insured[this.insRelKeys[idx]] === 'Lender/Mortgagee'
                                                    || insured[this.insRoleKeys[idx]] === 'Lender/Mortgagee')) {	
                                                    option.defaultChecked = true;	
                                                }	
                                                else if (idx === 1 && secondAdditionalInsuredForms.includes(option.value)
                                                    && ((insured.approvedForms && insured.approvedForms.includes(option.value)) || insured[this.insRelKeys[idx]] === 'Lender/Mortgagee'
                                                    || insured[this.insRoleKeys[idx]] === 'Lender/Mortgagee')) {	
                                                    option.defaultChecked = true;	
                                                }	
                                                else if (idx === 2 && thirdAdditionalInsuredForms.includes(option.value)
                                                    && ((insured.approvedForms && insured.approvedForms.includes(option.value)) || insured[this.insRelKeys[idx]] === 'Lender/Mortgagee' 
                                                    || insured[this.insRoleKeys[idx]] === 'Lender/Mortgagee')) {	
                                                    option.defaultChecked = true;	
                                                } else {	
                                                    option.defaultChecked = false;	
                                                }
                                                return (	
                                                    <Checkbox
                                                        key={`checkbox-group-input-${index}`} name={option.value} disabled={option.disabled} defaultChecked={option.defaultChecked} onChange={(e) => this.handleChangeOption(e, idx)}>{option.label}</Checkbox>	
                                                );	
                                            })}	
                                        </FormGroup>	
                                    </Panel.Body>	
                                </Panel>	
                            )}	
                        </PanelGroup>	
                    </div>	
                </div>	
            </div>	
        )	
    }	
}	
AdditionalInsuredSelector.propTypes = {	
    onChange: PropTypes.func,	
    updateAdditionalInsuredList: PropTypes.func	
};